export default __webpack_public_path__ + "static/media/crossroads11.854d3ba1.webp";